import cn from 'classnames'
import {Link} from 'react-router'
import styles from './task-row.module.scss'

const STATUS_LABEL = {
    pending: 'Pending',
    in_progress: 'In progress',
    delayed: 'Delayed',
    blocked: 'Blocked',
    resolved: 'Resolved'
}

/**
 * @param {{ task: import('../../api/types.js').Task }} props
 */
export function TaskRow({task}) {
    const priorityClass = task.priority >= 4 ? 'priorityHigh' : task.priority >= 3 ? 'priorityMid' : 'priorityLow'
    const priorityLabel = task.priority >= 4 ? 'High' : task.priority >= 3 ? 'Medium' : 'Low'

    return (
        <Link to={`/tasks/${task.id}`} className={cn(styles.row, styles[priorityClass])}>
            <div className={styles.lead}>
                <span className={styles.priorityChip} aria-label={`Priority ${priorityLabel}`}>{priorityLabel}</span>
                <span className={cn(styles.statusDot, styles[`status-${task.status}`])} aria-hidden="true"/>
            </div>
            <div className={styles.main}>
                <p className={styles.title}>{task.title}</p>
                <p className={styles.meta}>
                    <span>{STATUS_LABEL[task.status] || task.status}</span>
                    {task.dueAt && (
                        <>
                            <span className={styles.dot}>·</span>
                            <span>Due {new Date(task.dueAt).toLocaleDateString()}</span>
                        </>
                    )}
                </p>
            </div>
        </Link>
    )
}
